import { eventType, TEventType } from './interfaces';

/**
 * Checks if an event type is a secondary event.
 * @param type - The type to check.
 * @returns {boolean} - If the event type is a secondary event.
 */
export const isSecondaryEventType = (type: TEventType): boolean =>
  type === eventType.EmailEvent || type === eventType.ShippingEvent;
